var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3404 3.56163C20.5187 2.73987 19.1943 2.73987 18.3725 3.56163L4.26281 17.6714C3.44104 18.4931 3.44104 19.8175 4.26281 20.6393C4.6737 21.0502 5.22188 21.233 5.76967 21.233C6.31746 21.233 6.86566 21.0505 7.27654 20.6393L21.3863 6.52954C22.1625 5.70778 22.1625 4.38372 21.3404 3.56163Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65016 5.5243C9.65016 7.41563 8.1168 8.94899 6.22547 8.94899C4.33415 8.94899 2.80078 7.41563 2.80078 5.5243C2.80078 3.63265 4.33415 2.09961 6.22547 2.09961C8.1168 2.09961 9.65016 3.63265 9.65016 5.5243Z",
    fill: "#A0AEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8006 18.6747C22.8006 20.566 21.2672 22.0994 19.3759 22.0994C17.4845 22.0994 15.9512 20.566 15.9512 18.6747C15.9512 16.7834 17.4845 15.25 19.3759 15.25C21.2672 15.25 22.8006 16.7834 22.8006 18.6747Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/Percentage.80e695d2a6a231b643acde2fd0d1f691.svg";
export { ForwardRef as ReactComponent };